import React, { Component } from "react";
import styled from "styled-components";

export default class StoryWe extends Component {

   render() {

      const StoryWe = styled.div`
   flex: 0 0 30%;
   margin-top: 1rem;
   @media (max-width:47.94rem) {
      display:block;
   }
`
      const StoryWeImage = styled.div`
position: relative;
padding-bottom: 160%;
min-width: 7.5rem;
img{
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   object-fit: cover;
}
`
      const StoryWeTitle = styled.div`
position: absolute;
z-index: 10;
color: rgba(255, 255, 255, 1);
font-size: 1.5rem;
font-weight:900;
text-transform: uppercase;
padding: 1%;
line-height: 1.8rem;
@media (max-width:47.94rem) {
   font-size: 2.5rem;
   line-height: 3rem;
}
`

      return (
         <StoryWe>
            <StoryWeTitle>
               We <br />
               {this.props.options['text']}
            </StoryWeTitle>
            <StoryWeImage>
               <img src={require(`./Image__Story-jpg/${this.props.options['img']}.jpg`)} alt="Изображение по теме заголовка" />
            </StoryWeImage>
         </StoryWe>
      )
   }
}